import { render } from "./WCResetIndexModal.vue?vue&type=template&id=471d5ea1&ts=true"
import script from "./WCResetIndexModal.vue?vue&type=script&lang=ts"
export * from "./WCResetIndexModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__